const useAbsoluteUrl = () => {
    return (path?: string) =>
        path && path.startsWith('https://')
            ? path
            : new URL(
                path || '',
                window.location.origin,
            ).toString();
};

export default useAbsoluteUrl;
